import { createFileRoute } from "@tanstack/react-router"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { Header } from "~/components/reusable/Header"
import { internalRouteGuard } from "~/utils/routeGuards"

export const Route = createFileRoute("/_auth/prototype/")({
  beforeLoad: internalRouteGuard,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col h-full">
      <Header>
        <BreadcrumbWrapper items={[{ label: "Prototypes" }]} />
      </Header>

      <div className="flex flex-1 items-center justify-center">
        <p className="text-fg-subtle">Select a prototype from the sidebar</p>
      </div>
    </div>
  )
}
